import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Opponent cancelled the draw proposal" notification. Subject is the battle's discussion.
 * content: { cancellerName }
 */
export default class DrawCancelledNotification extends Notification {
  icon() {
    return 'fas fa-rotate-left';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    const user = this.attrs.notification.fromUser();
    const content = this.attrs.notification.content() || {};
    const name = user?.displayName() ?? content.cancellerName ?? '?';
    return app.translator.trans('forumaker-arena.forum.notifications.draw_cancelled_text', {
      canceller: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/DrawCancelledNotification', DrawCancelledNotification);